import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as navigation from "../../utils/navigation.js";
import * as rwData from "../../utils/rwData.js";

const Link = (props) => {
  //========================================================================
  // State für den "gedrückt" Zustand
  const [isPressed, setIsPressed] = useState(false);

  //========================================================================
  // Seite wechseln
  const handleInputChange = () => {
    if (props.authWrite) {
      navigation.changePage("custom", props.props.path);
    }
  };

  //========================================================================
  // Maus-Event-Handler
  const handleMouseDown = () => {
    setIsPressed(true);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
    handleInputChange();
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const handleTouchStart = () => {
    setIsPressed(true);
  };

  const handleTouchEnd = () => {
    setIsPressed(false);
    handleInputChange();
  };

  //========================================================================
  // Grafische Darstellung
  return (
    <button
      style={{
        ...props.style,
        visibility: props.props.visibility,
        transform: `${props.element.transform} ${
          isPressed ? "scale(0.95)" : "scale(1)"
        }`,
        cursor: "pointer",
        transition: "transform 0.1s, box-shadow 0.1s",
        boxShadow: isPressed
          ? "inset 2px 2px 5px rgba(0,0,0,0.5)"
          : "2px 2px 5px rgba(0,0,0,0.3)",
        // border: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      title={
        language.displayText(props.props.text) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Pfad: " + props.props.path)
          : "")
      }
    >
      <div
        style={{
          overflow: "hidden",
          whiteSpace: "pre-wrap",
          boxSizing: "border-box",
          textAlign: props.style?.justifyContent
        }}
      >
        {language.displayText(props.props.text)}
      </div>
    </button>
  );
};

export default Link;
